import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import { Button } from '@wbk/ui';
import { Season } from '@wbk/api';
import { useQueue } from '@wbk/queue';
import Zoom from '../animation/Zoom';

type Props = {
  season: Season;
};

const ReserveSpotBanner = ({ season }: Props) => {
  const { t } = useTranslation();
  const { isActive } = useQueue();

  if (isActive) return null;

  return (
    <section className='bg-white py-12'>
      <Zoom as='div' duration={1} className='container relative text-center text-secondary-600'>
        <div className='relative z-10 space-y-6 overflow-hidden rounded-l px-4 py-10 shadow-lg before:absolute before:inset-0 before:-z-10 before:min-h-[400px] before:bg-[url("/images/banner-bg.jpg")] before:bg-cover before:bg-[50%_25%] before:bg-no-repeat'>
          <h2 className='text-4xl uppercase'>{t('tickets:yalla_reserve_your_spot')}</h2>

          <Button
            as={process.env.NEXT_PUBLIC_QUEUE === 'true' ? 'a' : Link}
            href={`/season/${season.slug}/book`}
            className='w-full max-w-xs text-lg font-bold ring-offset-primary'
            theme='tertiary'
          >
            {t('tickets:buy_now')}
          </Button>
        </div>
      </Zoom>
    </section>
  );
};

export default ReserveSpotBanner;
